import { RouterView, type RouteRecordRaw } from "vue-router";
import { ROUTE_NAME } from "@/shared/constants/routes";
import { h } from "vue";

export const routes: RouteRecordRaw[] = [
  {
    path: "/calendars",
    name: ROUTE_NAME.CALENDARS,
    component: { render: () => h(RouterView) },
    redirect: { name: ROUTE_NAME.WORKOUT_LIST },
    children: [
      {
        path: "workouts",
        name: ROUTE_NAME.WORKOUTS,
        component: { render: () => h(RouterView) },
        redirect: { name: ROUTE_NAME.WORKOUT_LIST },
        children: [
          {
            path: "",
            name: ROUTE_NAME.WORKOUT_LIST,
            component: () => import("./views/WorkoutList.vue"),
          },
          {
            path: ":id",
            name: ROUTE_NAME.WORKOUT_UPDATE,
            component: () => import("./views/WorkoutUpdate.vue"),
          },
          {
            path: "create/:day/:type/:weights",
            name: ROUTE_NAME.WORKOUT_CREATE,
            component: () => import("./views/WorkoutCreate.vue"),
          },
        ],
      },
      {
        path: "exercises",
        name: ROUTE_NAME.EXERCISES,
        component: { render: () => h(RouterView) },
        redirect: { name: ROUTE_NAME.EXERCISE_LIST },
        children: [
          {
            path: "",
            name: ROUTE_NAME.EXERCISE_LIST,
            component: () => import("./views/ExerciseList.vue"),
          },
          {
            path: ":id",
            name: ROUTE_NAME.EXERCISE_UPDATE,
            component: () => import("./views/ExerciseUpdate.vue"),
          },
          {
            path: "create",
            name: ROUTE_NAME.EXERCISE_CREATE,
            component: () => import("./views/ExerciseCreate.vue"),
          },
        ],
      },
    ],
  },
];
